"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = exports.defaultButtonDefaultProps = exports.defaultButtonPropTypes = exports.ButtonSize = exports.ButtonType = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _emotionTheming = require("emotion-theming");

var _Button = require("./Button.style");

var _Icon = _interopRequireDefault(require("../Icon"));

var _Loader = _interopRequireDefault(require("../Loader"));

var _withOptionalLink = _interopRequireDefault(require("../HOC/withOptionalLink"));

var ButtonType = {
  Primary: 'primary',
  Secondary: 'secondary',
  Link: 'link'
};
exports.ButtonType = ButtonType;
var ButtonSize = {
  Large: 'large',
  Small: 'small'
};
exports.ButtonSize = ButtonSize;

var DefaultButton = function DefaultButton(_ref) {
  var as = _ref.as,
      variant = _ref.variant,
      children = _ref.children,
      disabled = _ref.disabled,
      size = _ref.size,
      loading = _ref.loading,
      inverted = _ref.inverted,
      startIcon = _ref.startIcon,
      endIcon = _ref.endIcon,
      url = _ref.url,
      rest = _objectWithoutProperties(_ref, ["as", "variant", "children", "disabled", "size", "loading", "inverted", "startIcon", "endIcon", "url"]);

  var _ref2 = (0, _emotionTheming.useTheme)(),
      slug = _ref2.slug; // make sure that all Lions Creativity external links show external link icon


  var isExternalLinkLC = slug === 'lionsCreativity' && url && url.toLowerCase().indexOf('http') >= 0; // link url contains a downloadable file

  var isDownload = url && (url.toLowerCase().includes('.pdf') || url.toLowerCase().includes('.zip')); // link url is a mail link

  var isMail = url && url.toLowerCase().includes('mailto:');
  var appliedEndIcon = endIcon;

  if (isExternalLinkLC) {
    appliedEndIcon = 'ExternalLink';
  }

  if (isMail) {
    appliedEndIcon = 'Mail';
  }

  if (isDownload) {
    appliedEndIcon = 'Download';
  }

  var iconSize = size === ButtonSize.Large ? '24px' : '18px';
  var iconProps = {
    marginX: variant === ButtonType.Link ? 0 : 'small',
    size: iconSize,
    spaceAround: false
  };
  var darkIconNeeded = variant === ButtonType.Primary && inverted || variant === ButtonType.Secondary && !inverted;
  var hasLabel = !!children;
  return /*#__PURE__*/_react.default.createElement(_Button.Wrapper, Object.assign({
    as: as,
    disabled: disabled || loading,
    inverted: inverted,
    size: size,
    variant: variant,
    hasLabel: hasLabel
  }, rest), /*#__PURE__*/_react.default.createElement(_Button.Content, {
    toggle: loading
  }, startIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, Object.assign({
    name: startIcon
  }, iconProps)), hasLabel && /*#__PURE__*/_react.default.createElement(_Button.ButtonText, {
    endIcon: appliedEndIcon,
    inverted: inverted,
    size: size,
    startIcon: startIcon,
    variant: variant
  }, children), appliedEndIcon && /*#__PURE__*/_react.default.createElement(_Icon.default, Object.assign({
    name: appliedEndIcon
  }, iconProps))), loading && /*#__PURE__*/_react.default.createElement(_Button.LoaderWrapper, null, /*#__PURE__*/_react.default.createElement(_Loader.default, {
    color: darkIconNeeded ? '#262626' : 'white'
  })));
};

var defaultButtonPropTypes = {
  /** An HTML tag used to render the component */
  as: _propTypes.default.string,

  /** Button text */
  children: _propTypes.default.string,

  /** Icon at the beginning of the button */
  startIcon: _propTypes.default.node,

  /** Icon at the end of the button */
  endIcon: _propTypes.default.node,

  /** Button style */
  variant: _propTypes.default.oneOf(Object.values(ButtonType)),

  /** Button size */
  size: _propTypes.default.oneOf(Object.values(ButtonSize)),

  /** Button is in loading state */
  loading: _propTypes.default.bool,

  /** Button can or cannot be clicked */
  disabled: _propTypes.default.bool,

  /** Inverted color scheme */
  inverted: _propTypes.default.bool,

  /** Url used in links */
  url: _propTypes.default.string
};
exports.defaultButtonPropTypes = defaultButtonPropTypes;
var defaultButtonDefaultProps = {
  as: 'button',
  children: null,
  startIcon: null,
  endIcon: null,
  variant: ButtonType.Primary,
  size: ButtonSize.Large,
  loading: false,
  disabled: false,
  inverted: false,
  url: undefined
};
exports.defaultButtonDefaultProps = defaultButtonDefaultProps;
DefaultButton.propTypes = defaultButtonPropTypes;
DefaultButton.defaultProps = defaultButtonDefaultProps;

var _default = (0, _withOptionalLink.default)(DefaultButton);

exports.default = _default;